{
  "de": {
    "todo_group": {
      "actions": {
        "create": "Aufgabe",
        "update": "Aufgabe bearbeiten"
      },
      "attributes": {
        "category": "Kategorie",
        "created_at": "Erstellt",
        "description": "Beschreibung",
        "title": "Titel",
        "todos_count": "Aufgaben",
        "units": "Einheiten"
      },
      "categories": {
        "confirmation": "Bestätigung",
        "upload": "Hochladen"
      },
      "labels": {
        "no_groups": "Noch keine Aufgaben für dieses Projekt.",
        "required": "Dieses Feld ist erforderlich"
      },
      "toasts": {
        "create": "Aufgabe erstellt",
        "delete": "Aufgabe gelöscht",
        "update": "Aufgabe aktualisiert"
      }
    }
  }
}
